"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var operators_1 = require("rxjs/operators");
/**
 * @author armen.avagumyan on 5/31/2017.
 */
var FUtil = /** @class */ (function () {
    function FUtil() {
    }
    FUtil.getMultilingualString = function (languages, text) {
        text = text ? text : "";
        var multilingualStringBuilder = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
        languages.forEach(function (language) {
            var languageId = language.getId();
            multilingualStringBuilder.withValueForLanguage(languageId, text);
        });
        return multilingualStringBuilder.build();
    };
    // static newFItemClassifierCustom(id: number, name: MultilingualString, parentId: number, kbFrameworkSysName: string, level: number, isFake?: boolean, defineOrder?: boolean, code?: string, orderId?: number): Classifier {//TODO remove
    //     let identityField = kbFrameworkSysName + level + "ID";
    //     let parentIdentityField = level === 1 ? "FrameworkID" : kbFrameworkSysName + (level - 1) + "ID";
    //     let properties: Map<string, PropertyValue<any>> = new Map<string, PropertyValue<any>>();
    //     properties.set(identityField, new PropertyValueAccessor<number>(id));
    //     properties.set("ID", new PropertyValueAccessor<number>(id));
    //     properties.set(parentIdentityField, new PropertyValueAccessor<number>(parentId));
    //     properties.set("name", new PropertyValueAccessor<MultilingualString>(name));
    //     properties.set("Code", new PropertyValueAccessor<string>(code));//TODO
    //     properties.set("DeletedBy", new PropertyValueAccessor(null));
    //     properties.set("DeletedOn", new PropertyValueAccessor(null));
    //     if (level === 2 || level === 4) {//TODO properties
    //         properties.set("IsFake", new PropertyValueAccessor<boolean>(!!isFake));
    //     }
    //     if(defineOrder){
    //         properties.set("OrderID", new PropertyValueAccessor<number>(orderId));
    //     }
    //     let classifier: Classifier = new Classifier(properties, identityField, identityField);
    //     return classifier;
    // }
    FUtil.newFItemClassifier = function (classifierService, framework, level1ParentFieldName, id, name, parentId, kbFrameworkSysName, level, isFake, defineOrder, code, orderId) {
        var identityField = kbFrameworkSysName + level + "ID";
        var parentIdentityField = level === 1 ? level1ParentFieldName : kbFrameworkSysName + (level - 1) + "ID";
        return classifierService.createDummyClassifier(kbFrameworkSysName + level).pipe(operators_1.tap(function (classifier) {
            classifier.getProperty(identityField).value = id ? id : null;
            // classifier.getProperty("ID").value = id;
            classifier.getProperty(parentIdentityField).value = parentId;
            classifier.getProperty("Code").value = code ? code : null;
            classifier.getProperty("name").value = name;
            classifier.getProperty("DeletedBy").value = null;
            classifier.getProperty("DeletedOn").value = null;
            if (level > 1 && !FUtil.isAvailable(level, framework.levels)) { //TODO properties
                classifier.getProperty("IsFake").value = !!isFake;
            }
            if (defineOrder) {
                try { //TODO a.a
                    classifier.getProperty("OrderID").value = orderId;
                }
                catch (e) {
                    console.log("Item no contains OrderID");
                }
            }
        }));
    };
    FUtil.getItemRecursive = function (list, selectedItems, currentLevel, level, levels, maxLevel) {
        var item = FUtil.getItemFromList(list, selectedItems[currentLevel].selectedClassifierId);
        return currentLevel === level ? item : FUtil.getItemRecursive(item.items, selectedItems, FUtil.getChildLevel(currentLevel, maxLevel, levels), level, levels, maxLevel);
    };
    /**
     *
     * @param list
     * @param id
     * @returns {null}
     */
    FUtil.getItemFromList = function (list, id) {
        for (var i = 0; i < list.length; i++)
            if (list[i].data.getId() === id)
                return list[i];
        return null;
    };
    /**
     * Method return Available Levels array
     * @returns {number[]}
     */
    FUtil.getAllAvailableLevelNumbers = function (levels) {
        var levelNumbers = [];
        FUtil.getAvailableFrameworkLevels(levels).forEach(function (value) {
            levelNumbers.push(value.level);
        });
        levelNumbers.sort(function (a, b) { return a - b; });
        return levelNumbers;
    };
    /**
     * Method return Available Levels array, for e.g. if selectedLevel is 3, method return [1, 2, 3]
     * @returns {number[]}
     */
    FUtil.getAvailableLevelNumbers = function (selectedLevel, levels) {
        var levelNumbers = [];
        FUtil.getAvailableFrameworkLevels(levels).forEach(function (value) {
            if (value.level < selectedLevel) {
                levelNumbers.push(value.level);
            }
        });
        levelNumbers.sort(function (a, b) { return a - b; });
        return levelNumbers;
    };
    /**
     * Method return true, if level is available
     */
    FUtil.isAvailable = function (level, levels) {
        return FUtil.getAllAvailableLevelNumbers(levels).indexOf(level) > -1;
    };
    FUtil.getChildLevel = function (level, maxLevel, levels) {
        var childLevel = level + 1;
        while (!FUtil.isAvailable(childLevel, levels) && childLevel <= maxLevel) {
            childLevel++;
        }
        return childLevel;
    };
    /**
     * Method return available parent level
     */
    FUtil.getParentLevel = function (level, levels) {
        var parentLevel = level - 1;
        while (!FUtil.isAvailable(parentLevel, levels) && parentLevel > 1) {
            parentLevel--;
        }
        return parentLevel;
    };
    /**
     * method return framework all available levels
     */
    FUtil.getAvailableFrameworkLevels = function (levels) {
        var availableFrameworkLevels = [];
        levels.forEach(function (value) {
            if (value.enabled) { //TODO
                availableFrameworkLevels.push(value);
            }
        });
        availableFrameworkLevels.sort(function (a, b) { return a.level - b.level; });
        return availableFrameworkLevels;
    };
    FUtil.convertToNumber = function (array) {
        if (!array)
            new Error("Illegal parameter!");
        var numArray = new Array(array.length);
        array.forEach(function (value, index, array2) { return numArray[index] = Number(value); });
        return numArray;
    };
    /**
     * Method remove from list deleted and duplicated classifiers
     * classifierService bug TODO A.A. remove after update classifier service client
     * @param {Array<Classifier>} data
     */
    FUtil.filter = function (data) {
        if (!data || data.length == 0) {
            return data;
        }
        var items = [];
        data.forEach(function (value) {
            if (!FUtil.isDeleted(value) && FUtil.getFromArrayById(items, value.getId()) == null) {
                items.push(value);
            }
            else {
                console.log("duplicated or removed " + value);
            }
        });
        return items;
    };
    /**
     * Method return true if classifier is deleted
     * @param {Classifier} value
     * @returns {boolean}
     */
    FUtil.isDeleted = function (value) {
        return value.getProperty("DeletedBy").value != null;
    };
    /**
     * Method find and return classifier by id
     * @param {Classifier[]} items
     * @param {number} id
     * @returns {Classifier}
     */
    FUtil.getFromArrayById = function (items, id) {
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (item.getId() === id) {
                return item;
            }
        }
        return null;
    };
    /**
     * For [2, 4] method should return [2, 3, 4, 5]
     * @param {Array<number>} enabledLevels
     * @param {number} maxLevel
     * @returns {Array<number>}
     */
    FUtil.allChildLevels = function (enabledLevels, maxLevel) {
        if (!enabledLevels || enabledLevels.length === 0) {
            return enabledLevels;
        }
        enabledLevels.sort(function (a, b) { return a - b; });
        var levels = [];
        for (var level = enabledLevels[0]; level <= maxLevel; level++) {
            levels.push(level);
        }
        return levels;
    };
    /**
     * Method find and return all FItems from Framework tree by level
     */
    FUtil.findItemsByLevel = function (framework, level, fItems, parentId, list) {
        if (!list) {
            list = [];
        }
        if (!fItems) {
            fItems = framework.items;
        }
        if (fItems.length == 0) {
            return list;
        }
        for (var _i = 0, fItems_1 = fItems; _i < fItems_1.length; _i++) {
            var fItem = fItems_1[_i];
            if (fItem.level < level) {
                FUtil.findItemsByLevel(framework, level, fItem.items, parentId, list);
            }
            else if (fItem.level === level && (!parentId || fItem.parent.id === parentId)) {
                list.push(fItem);
            }
        }
        return list;
    };
    /**
     * For e.g, if enabled levels are 2 and 4, method reset child items from first level items
     */
    FUtil.resetEnabledLevels = function (framework, enabledLevels) {
        if (enabledLevels.length !== 0) {
            var resetLevel = Math.min.apply(Math, enabledLevels) - 1;
            FUtil.findItemsByLevel(framework, resetLevel).forEach(function (fItem) { return fItem.items = null; });
        }
    };
    return FUtil;
}());
exports.FUtil = FUtil;
//# sourceMappingURL=framework.util.js.map